//natives
import React from 'react';
import MUIDataTable from "mui-datatables";
import {MuiThemeProvider, createTheme} from '@material-ui/core';

import Columns from '../childrens/columns/.mixins';
import CustomHeader from '../childrens/customHeader/.mixins';
import TextLabels from '../../../../../../../../../../../util/Table/.mixins/TextLabels';

var Background = '/images/watermarkLine.png';

export default (props) => {

    const columns = Columns;
    const data = props.data;
    const options = {
        filter: false,
        download: false,
        search: false,
        viewColumns: false,
        selectableRows: 'none',
        rowsPerPage: 10,
        textLabels: TextLabels,
        responsive: 'vertical'
    };
    const theme = createTheme({
        palette: {
            primary: {
              main: '#159B78',
            },
            secondary: {
                main: '#159B78',
            },
            text: {
              primary: '#666666'
            },
            type: 'light',
        },
        overrides: {
            MuiDataTable: {
                root: {
                    backgroundImage: `url(${Background})`,
                    BackgroundColor: 'rgba(0,0,0,0)'
                }
            },
            MuiPaper: {
                root: {
                    backgroundImage: `url(${Background})`,
                    BackgroundColor: 'rgba(0,0,0,0)'
                }
            },
            MuiTableCell: {
                root: {
                    backgroundImage: `url(${Background})`,
                    BackgroundColor: 'rgba(0,0,0,0)'
                }
            },
        }
    });

    return (
        <MuiThemeProvider theme={theme}>
            <MUIDataTable 
                title={<CustomHeader {...props}/>} 
                data={data} 
                columns={columns} 
                options={options}
            />
        </MuiThemeProvider>
    );
}